import React, { useState, useCallback, useEffect ,useRef} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import questions360 from "../questiondatas/questions360";
import questions360mgr from "../questiondatas/questions360mgr";
import axios from "axios";
import Modal from "../resultcomponent/ModalBox";
import "./surveyform.css";

const logoSrc = "./unexttitlebar.png";
const logoSrcnew = "./iogo1.png";
const SurveyForm = () => {

  
  const navigate = useNavigate();
  
 const selectRefs = useRef([]);

// newly added state for unaswerd questions
const [unansweredIndexes, setUnansweredIndexes] = useState([]);
const [progressStatus, setProgressStatus] = useState("normal"); 
// normal | error | complete

const feedbackType = localStorage.getItem("feedbackType");
const targetName = localStorage.getItem("feedbackTargetName");
const targetUserId = localStorage.getItem("targetUserId");
const programId = localStorage.getItem("programId");
const isSelf = feedbackType === "Self";

  // ✅ Feedback giver details from localStorage
  const userId = localStorage.getItem("userId");
  const username = localStorage.getItem("username");
  const role = localStorage.getItem("role");

  // ✅ Pick correct question set
 // const questionSet = role === "Manager" ? questions360mgr : questions360;

 let questionSet;

if (feedbackType?.toLowerCase() === "self") {
  questionSet = questions360; // self feedback → load from questions360.js
} else if (
  ["peer", "manager", "reportee", "reportsto"].includes(feedbackType?.toLowerCase())
) {
  questionSet = questions360mgr; // peer, manager, reportee, or reportsTo
} else {
  questionSet = questions360; // fallback
}

  const [responses, setResponses] = useState(
    Array(questionSet.length).fill(null)
  );
  const [error, setError] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);

  // Timer logic (20 mins)
  const [timeLeft, setTimeLeft] = useState(() => {
    const storedStartTime = sessionStorage.getItem("startTime");
    if (!storedStartTime) {
      sessionStorage.setItem("startTime", Date.now().toString());
      return 1800;
    }
    const elapsed = Math.floor(
      (Date.now() - parseInt(storedStartTime, 10)) / 1000
    );
    return Math.max(1800 - elapsed, 0);
  });
useEffect(() => {
  window.history.replaceState(null, "", window.location.pathname);
}, []);
  useEffect(() => {
    if (timeLeft <= 0) {
      setModalMessage("Your time has expired. You will be logged out.");
      setIsModalVisible(true);
      return;
    }
    const interval = setInterval(() => {
      setTimeLeft((prev) => Math.max(prev - 1, 0));
    }, 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);

  useEffect(() => {
    setResponses(Array(questionSet.length).fill(null));
    setHasSubmitted(false);
  }, [targetUserId, questionSet]);

  // Modal states
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [pendingSubmission, setPendingSubmission] = useState(false);
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);

  const ratingMap = {
    "Strongly Disagree": 1,
    Disagree: 2,
    Neutral: 3,
    Agree: 4,
    "Strongly Agree": 5,
  };

  // Modal confirm handler
  const handleModalConfirm = async () => {
    setIsModalVisible(false);

    if (modalMessage === "Your time has expired. You will be logged out.") {
      sessionStorage.clear();
      navigate("/logout");
      return;
    }

    if (pendingSubmission) {
      try {
        // ✅ Build final payload with all required fields
        const payload = {
          userId,
          targetUserId: isSelf ? userId : targetUserId,
          programId,
          //feedbackType,
          responses: questionSet.map((q, i) => ({
            questionId: q.id,
            questionText: q.text,
            response_text: responses[i] || null,
            response_value: responses[i] ? ratingMap[responses[i]] : 0,
          })),
        };

        await axios.post("/api/submit-survey", payload);

        setResponses(Array(questionSet.length).fill(null));
setUnansweredIndexes([]);
setHasSubmitted(false);
setPendingSubmission(false);
        setModalMessage("Survey submitted successfully!");
        setIsSuccessModalVisible(true);

        localStorage.clear();
        sessionStorage.clear();
        navigate("/logout", { state: { responses } });
      } catch (err) {
        console.error("Error submitting survey:", err);
        setModalMessage(
          "An error occurred while submitting the survey. Please try again."
        );
        setIsModalVisible(true);
      }
    }
  };

  const handleSuccessModalConfirm = () => {
    setIsSuccessModalVisible(false);
  };

/*const handleSubmit = useCallback(
  (event) => {
    if (event) event.preventDefault();

    setHasSubmitted(true);

    const missing = responses
      .map((res, idx) => (res === null ? idx : null))
      .filter((idx) => idx !== null);

    if (missing.length > 0) {
      setUnansweredIndexes(missing);
      setModalMessage("Please provide a response to all the highlighted questions.");
      setIsModalVisible(true);
      return;
    }

    setUnansweredIndexes([]);
    setError(false);
    setModalMessage("Click OK to proceed");
    setPendingSubmission(true);
    setIsModalVisible(true);
  },
  [responses]
);
*/



const handleSubmit = useCallback(
  (event) => {
    if (event) event.preventDefault();

    setHasSubmitted(true);

    const missing = responses
      .map((res, idx) => (res === null ? idx : null))
      .filter((idx) => idx !== null);

    if (missing.length > 0) {
      setUnansweredIndexes(missing);
setProgressStatus("error"); // 🔴 turn red
      // ✅ AUTO SCROLL + FOCUS FIRST UNANSWERED QUESTION
      const firstIndex = missing[0];
      const el = selectRefs.current[firstIndex];

      if (el) {
        setTimeout(() => {
          el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          el.focus();
        }, 100);
      }

      setModalMessage(
        "Please provide a response to all the highlighted questions."
      );
      setIsModalVisible(true);
      return;
    }

    // all answered
    setProgressStatus("complete"); 
    setUnansweredIndexes([]);
    setError(false);
    setModalMessage("Click OK to proceed");
    setPendingSubmission(true);
    setIsModalVisible(true);
  },
  [responses]
);
  const handleChange = (index, value) => {
    const updated = [...responses];
    updated[index] = value;
    setResponses(updated);

    // Remove highlight when answered
  setUnansweredIndexes((prev) => prev.filter((i) => i !== index));

const answeredCount = updated.filter(
    (res) => res !== null && res !== ""
  ).length;

  if (answeredCount === questionSet.length) {
    setProgressStatus("complete"); // 🟢
  } else {
    setProgressStatus("normal"); // 🔵
  }
};

  const handleModalCancel = () => {
    setIsModalVisible(false);
    setPendingSubmission(false);

  // if (unansweredIndexes.length > 0) {
  //   const firstIndex = unansweredIndexes[0];
  //   const el = selectRefs.current[firstIndex];

  //   if (el) {
  //     setTimeout(() => {
  //       el.scrollIntoView({
  //         behavior: "smooth",
  //         block: "center",
  //       });
  //       el.focus();
  //     }, 200);
  //   }
  // }
};
const handleLogout = () => {
  localStorage.clear();
  sessionStorage.clear();
  navigate("/logout"); // or "/login" based on your routing
};
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;

  
    return (
      <span style={{ color: "orange" }}>
        {minutes.toString().padStart(2, "0")}:{secs.toString().padStart(2, "0")}
      </span>
    );
  };

const totalQuestions = questionSet.length;

const answeredCount = responses.filter(
  (res) => res !== null && res !== ""
).length;

const progressPercent = Math.round(
  (answeredCount / totalQuestions) * 100
);

  return (
    <div className="survey-form-wrapper">
      <div className="top-left-instructions">
        <h4 className="sidepanel">Providing Feedback</h4>
        <p>Please provide your feedback on the respective areas using the scale</p>
        <ul>
          <li>1 - Strongly Disagree</li>
          <li>2 - Disagree</li>
          <li>3 - Neutral</li>
          <li>4 - Agree</li>
          <li>5 - Strongly Agree</li>
        </ul>
      </div>

      <div className="survey-form-page">
        <header className="header">
          {/* <h4 className="maintitle">Survey 360°</h4> */}
           <img src={logoSrcnew} alt="Survey 360° Logo" className="maintitle-logo"/>
   {(isSelf || targetName) && (
  <p
    style={{
      marginTop: "-3px",
      marginBottom: "0",
      fontSize: "14px",
      color: "black",
      fontWeight: 500,
      position: "relative",
      left: "-72px",
    }}
  >
  Hi,  You are giving feedback for{" "}
    <strong>{isSelf ? "yourself" : targetName}</strong>
  </p>
)}

          <div className="welcome-container">
            <span className="welcome-message">
            Welcome, {username} 
          </span>
          <button
    type="button"
    className="logout-button"
    onClick={handleLogout}
  >
    Logout
  </button>
          <div className="logo-container">
            <img src={logoSrc} alt="Logo" className="logo" />
             
          </div>
        </div>

        </header>

        <form onSubmit={handleSubmit} className="survey-form">
  
          <div className="questionnaire">
      
            <table className="survey-table">
              <thead>
                <tr>
                  <th>Q.#</th>
                  <th>Question</th>
                  <th>Option</th>
                </tr>
              </thead>
              <tbody>
                {questionSet.map((q, index) => (
                  <tr key={q.id}  className={unansweredIndexes.includes(index) ? "unanswered-row" : ""}>
                    <td>{q.id}</td>
                    <td>{q.text}</td>
                    <td>
                      <select 
                      ref={(el) => (selectRefs.current[index] = el)}
                      className={unansweredIndexes.includes(index) ? "unanswered-select" : ""}
                        value={responses[index] || ""}
                        onChange={(e) => handleChange(index, e.target.value)}
                      >
                        <option value="" disabled>
                          Please Choose
                        </option>
                        {Object.keys(ratingMap).map((opt, idx) => (
                          <option key={idx} value={opt}>
                            {opt}
                          </option>
                        ))}
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
  {/* Progress Bar */}
  
<div className="progress-wrapper">
  <div className="progress-text">
    Answered {answeredCount} / {totalQuestions} ({progressPercent}%)
  </div>

  <div className="progress-bar">
    <div
      className={`progress-fill ${progressStatus}`}
      style={{ width: `${progressPercent}%` }}
    >
      <span className="progress-percent">
        {progressPercent}%
      </span>
    </div>
  </div>

</div>


          <button type="submit" className="submit-button-survey">
            Submit
          </button>
          {hasSubmitted && error && (
            <p className="error-message">
              Please provide a response to all the questions.
            </p>
          )}
        </form>

        <div className="timer">Time Remaining: {formatTime(timeLeft)}</div>
      </div>

      {isModalVisible && (
        <Modal
          message={modalMessage}
          onConfirm={handleModalConfirm}
          onCancel={handleModalCancel}
          hideCancelButton={
            modalMessage === "Your time has expired. You will be logged out." ||
            modalMessage === "Please provide a response to all the questions."
          }
        />
      )}

      {isSuccessModalVisible && (
        <Modal
          message={modalMessage}
          onConfirm={handleSuccessModalConfirm}
          hideCancelButton={true}
        />
      )}

      <div className="footersurvey">
        © {new Date().getFullYear()} UNext Learning Pvt Ltd
      </div>
    </div>
  );
};

export default SurveyForm;
